import ChooseInformationOption from './GeneralnformationOption'

export default ChooseInformationOption



// WEBPACK FOOTER //
// ./src/app/elements/ChooseGeneralInformation/index.js